// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"Updater_reactMarkDown__QHIuI"};